// extracted by mini-css-extract-plugin
module.exports = {"userFilter":"UserFilter_userFilter__PVzN1","userFilter__people":"UserFilter_userFilter__people__3kPG1","userFilter__clearAll":"UserFilter_userFilter__clearAll__ONeXj"};